import { render, staticRenderFns } from "./StructureNode.vue?vue&type=template&id=e875ea66&"
import script from "./StructureNode.vue?vue&type=script&lang=ts&"
export * from "./StructureNode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports